"use client";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { LeftPanel } from "@/components/calculator/LeftPanel";
import { useCalculator } from "./hooks/useCalculator";
import { WizardCard } from "@/components/calculator/WizardCard";

export default function CostCalculatorPage() {
  const calc = useCalculator();

  return (
    <main className="min-h-screen bg-[#FAFAFA] overflow-x-hidden">
      <Navbar />

      <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-12 xl:px-20 2xl:px-32">
        <div className="max-w-[2200px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.1fr] gap-8 lg:gap-16 xl:gap-24 items-start">


            {/* Left static hero panel */}
            <div className="lg:sticky lg:top-24 min-w-0">
              <LeftPanel reviewIndex={calc.step - 1} />
            </div>

            {/* Right multi-step wizard */}
            <div className="min-w-0">
              <WizardCard
                step={calc.step}
                data={calc.data}
                update={calc.update}
                next={calc.next}
                back={calc.back}
                isValid={calc.isValid}
                isLast={calc.isLast}
                isFirst={calc.isFirst}                
              />
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
